import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { useLocalStorage } from "../../hooks";
import { dashboardState } from "../../redux/reducers/dashboardReducer";
import { userState } from "../../redux/reducers/userReducer";

import GoogleIcon from "../../assets/Google.png";
import AppleIcon from "../../assets/Apple.png";
import iDEALIcon from "../../assets/iDEAL.png";
import stripLogo from "../../assets/strip.png";
import tikkieLogo from "../../assets/tikkieLogo.svg";
import { TwButton, TwFormHelperText, TwInputGroup, TwLabel, TwLoadingIcon, TwMainLayout, TwSelectGroup, TwSwitch } from "../../components/tailwind";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading } from "../../redux/reducers/loadingReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForBookings, getUrlForUsers } from "../../utils/confighelpers";
import { defaultAvailablePaymentMethods } from "../../utils/constants";
import StripPaymentMethod from "./StripPaymentMethod";
import { isValidEmail } from "../../helpers";
import CardIcon from "../../assets/icons/CardIcon";
import PayoutScheduleForm from "./PayoutScheduleForm";
import { useTranslation } from "react-i18next";

export default function BusinessPaymentProfile({ navigation, screenView }) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog, closeNotificationDialog } = useToast();
  const [userToken] = useLocalStorage("userToken");
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const navigate = useNavigate();
  const location = useLocation();
  const dashboardReduxState = useSelector(dashboardState);
  const userReduxState = useSelector(userState);
  const [loading, setLoading] = React.useState(false);
  const [successMgModalOpen, setSuccessMgModalOpen] = React.useState(false);

  if (!userToken || userToken.length < 1) {
    navigate("/", { replace: true });
  }

  const handleFormValueChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    // setIsThereChange(false)
  };

  const bodyData = {
    businessId: "",
    isEnabled: false,
    accountHolderName: "",
    appToken: "",
    paymentType: "Tikkie",
    addedByUserId: userReduxState.userData?._id,
    profileDetails: {
      accountHolderName: "",
      appToken: "",
    },
  };
  const stripeBodyData = {
    businessId: "",
    isEnabled: false,
    paymentType: "Stripe",
    profileDetails: {},
    stripeDetails: {
      // }
    },
    addedByUserId: userReduxState.userData?._id,
  };

  const [formValues, setFormValues] = React.useState(bodyData);
  const [stripeFormValues, setStripeFormValues] = React.useState(stripeBodyData);
  const [isEditStripe, setIsEditStripe] = React.useState(false);
  const [isThereStripeChange, setIsThereStripeChange] = React.useState(true);
  const [formErrors, setFormErrors] = React.useState({});
  const [isEditTikkie, setIsEditTikkie] = React.useState(false);
  const [isThereChange, setIsThereChange] = React.useState({ addStripePayment: true, stripePaymentEnable: true, stripePaymentMethods: true, stripePayoutSchedule: true, addTikkiePayment: true });
  const [availablePaymentMethods, setAvailablePaymentMethods] = React.useState(defaultAvailablePaymentMethods);

  const [stripOnbordingFormValues, setStripOnbordingFormValues] = React.useState({
    email: userReduxState?.userData?.myBusinessProfile?.workEmail || "",
    country: "NL",
  });
  const [stripOnbordingFormErrors, setStripOnbordingFormErrors] = React.useState({});
  const [countryOpts, setEventCategoryOpts] = React.useState([
    { iso: "US", name: "United States" },
    { iso: "GB", name: "United Kingdom" },
    { iso: "NL", name: "Netherlands" },
    { iso: "IN", name: "India" },
    { iso: "AE", name: "UAE" },
  ]);

  const saveTikkiePaymentProfile = async () => {
    dispatch(setActionLoading(true));
    // setIsThereChange(true);

    const errors = {};
    if (!formValues.accountHolderName) {
      errors.accountHolderName = t("errors.required");
    }
    if (!formValues.appToken) {
      errors.appToken = t("errors.required");
    }

    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      dispatch(setGlobalLoading(false));
      dispatch(setActionLoading(false));
      setIsThereChange(false);
      addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
      return;
    }

    let body = {
      isEnabled: formValues.isEnabled,
      paymentType: formValues.paymentType,
      accountHolderName: formValues.accountHolderName,
      appToken: formValues.appToken,
      // // paymentType: formValues.paymentType,

      //   }
      // }
    };

    if (isEditTikkie) {
      body = {
        ...body,
        // businessId: formValues.businessId,
      }
    }
    await savePaymentProfile("tikkie", isEditTikkie, body);
    dispatch(setGlobalLoading(false));
    dispatch(setActionLoading(false));
    // setIsThereChange(true);
  };
  const saveStripePaymentProfile = async () => {
    dispatch(setActionLoading(true));
    setIsThereStripeChange(true);
    const errors = {};
    // if (!stripeFormValues.stripeDetails.paymentMethod.ideal
    if (!stripeFormValues.profileDetails.paymentMethod.ideal
      && !stripeFormValues.profileDetails.paymentMethod.applePay
      && !stripeFormValues.profileDetails.paymentMethod.googlePay
      && !stripeFormValues.profileDetails.paymentMethod.creditCard) {
      errors.paymentMethod = t("errors.onePaymentMethodRequired");
    }
    if (!stripeFormValues.profileDetails.stripeAcId) {
      errors.stripeAcId = t("errors.connectWithStripeAcc");
    }

    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      dispatch(setGlobalLoading(false));
      dispatch(setActionLoading(false));
      setIsThereStripeChange(false);
      addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
      return;
    }

    let body = {
      myConnectedPaymentProfiles: {
        stripe: {
          isEnabled: stripeFormValues.isEnabled,
          // paymentType: stripeFormValues.paymentType,
          // stripeDetails: stripeFormValues.stripeDetails,
          profileDetails: stripeFormValues.profileDetails,
        }
      }
    };

    if (isEditStripe) {
      body = {
        ...body,
      }
    }

    await savePaymentProfile("stripe", isEditStripe, body);
    dispatch(setActionLoading(false));
    setIsThereStripeChange(true);
  };

  const savePaymentProfile = async (editFor, isEdit, body) => {

    let config = {
      method: "post",
      url: `${getUrlForBookings()}payments/addPaymentProfile`,
      // method: "put",
      // url: `${getUrlForUsers()}updateProfile`,
      data: body,
    };
    if (isEdit) {
      config = {
        method: "PATCH",
        url: `${getUrlForBookings()}payments/updatePaymentProfile`,
        // method: "put",
        // url: `${getUrlForUsers()}updateProfile`,
        data: {
          ...body,
          // businessId: stripeFormValues.businessId,
        },
      }
      if (editFor === "stripe") {
        config = {
          ...config,
          method: "put",
          url: `${getUrlForUsers()}updateProfile`,
        }
      }
    }

    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    // const request = {};

    dispatch(setGlobalLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        if (isEdit) {
          addNotificationDialog({
            dialogType: "success",
            dialogTitle: t("successes.paymentProfileChangedSuccTitle"),
            // dialogMessage: (request.data.message || "Profile successfully updated!"),
            dialogMessage: t("successes.paymentProfileChangedSuccSubTitle", { profileType: editFor }),
            dialogBtnTitle: t("inputFieldsTitle.ok"),
          })
        } else {

          addNotificationDialog({
            dialogType: "success",
            dialogTitle: t("successes.paymentProfileChangedSuccTitle"),
            // dialogMessage: (request.data.message || "Profile successfully updated!"),
            dialogMessage: t("successes.paymentProfileAddedSuccSubTitle"),
            dialogBtnTitle: t("successes.paymentProfileAddedSuccBtn"),
            dialogBtnClick: async () => {
              closeNotificationDialog();
              navigate("/home/dashboard", { replace: true });
            },
          })
        }
        return;
      } else if (request.data.statusCode === 403) {
        addErrorToast(t("errors.somethingIsWrong"));
        // addErrorToast(request.data.message);
      }
    }

  };

  const getPaymentProfile = async (loading = true) => {
    dispatch(setGlobalLoading(loading));
    const manageClassesConfig = {
      method: "get",
      // url: `${getUrlForClasses()}getPaymentProfile?to=all&teacherID=${userReduxState.userData?._id}`,
      url: `${getUrlForUsers()}getUserInfo`,
    };
    setLoading(true)
    const manageClassesRequest = await axiosInstance(manageClassesConfig);
    dispatch(setGlobalLoading(false));
    if (manageClassesRequest.status === 200) {
      if (manageClassesRequest.data.statusCode === 403) {
        // setWarningText(manageClassesRequest.data.message.errors ? t("errors.somethingIsWrong") : manageClassesRequest.data.message);
        setIsEditTikkie(false)
        setFormValues(bodyData)
        // setIsThereChange(false)
      } else if (manageClassesRequest.data.statusCode === 200) {
        /* if (Array.isArray(manageClassesRequest.data.data)) {
          manageClassesRequest.data.data.map((d) => {
            if (d.paymentType === "Tikkie") {
              setIsEditTikkie(true);
              setFormValues({
                businessId: d._id,
                isEnabled: d.isEnabled,
                accountHolderName: d.accountHolderName,
                appToken: d.appToken,
                paymentType: d.paymentType,
                addedByUserId: userReduxState.userData?._id,
              })
              setIsThereChange(true)
            } else if (d.paymentType === "Stripe") {
              setIsEditStripe(true);
              setStripeFormValues({
                businessId: d._id,
                isEnabled: d.isEnabled,
                paymentType: d.paymentType,
                // stripeDetails: d.stripeDetails,
                stripeDetails: {
                  ...d.stripeDetails,
                  paymentMethod: {
                    ...d.stripeDetails?.paymentMethod,
                    ideal: d.stripeDetails?.paymentMethod?.ideal || false,
                    applePay: d.stripeDetails?.paymentMethod?.applePay || false,
                    googlePay: d.stripeDetails?.paymentMethod?.googlePay || false,
                    creditCard: d.stripeDetails?.paymentMethod?.creditCard || false,
                  },
                },
                addedByUserId: userReduxState.userData?._id,
              })
              setIsThereStripeChange(true)
            }
            return d;
          });
        } else */
        // if (manageClassesRequest.data.data.paymentType === "Stripe") {
        if (manageClassesRequest.data.data?.myConnectedPaymentProfiles?.stripe) {
          let stripeprofileDetails = manageClassesRequest.data.data.myConnectedPaymentProfiles.stripe
          // setIsEditStripe(true);
          setIsEditStripe(stripeprofileDetails?.profileDetails?.stripeAcId && stripeprofileDetails.profileDetails.stripeAcId !== "");
          setStripeFormValues({
            // businessId: manageClassesRequest.data.data._id,
            businessId: null,
            isEnabled: stripeprofileDetails.isEnabled,
            paymentType: "Stripe",
            // stripeDetails: manageClassesRequest.data.data.stripeDetails,
            // stripeDetails: {
            profileDetails: {
              ...stripeprofileDetails.profileDetails,
              stripeAcId: stripeprofileDetails?.profileDetails?.stripeAcId || "",
              stripeEmail: stripeprofileDetails?.profileDetails?.stripeEmail || "",
              stripeCountry: stripeprofileDetails?.profileDetails?.stripeCountry || "",
              stripeOnBoardindStatus: stripeprofileDetails?.profileDetails?.stripeOnBoardindStatus || "",
              paymentMethod: {
                ...stripeprofileDetails.profileDetails?.paymentMethod,
                ideal: stripeprofileDetails.profileDetails?.paymentMethod?.ideal?.enable ? stripeprofileDetails.profileDetails?.paymentMethod?.ideal : { enable: false, chargeToCustomer: false },
                applePay: stripeprofileDetails.profileDetails?.paymentMethod?.applePay?.enable ? stripeprofileDetails.profileDetails?.paymentMethod?.applePay : { enable: false, chargeToCustomer: false },
                googlePay: stripeprofileDetails.profileDetails?.paymentMethod?.googlePay?.enable ? stripeprofileDetails.profileDetails?.paymentMethod?.googlePay : { enable: false, chargeToCustomer: false },
                creditCard: stripeprofileDetails.profileDetails?.paymentMethod?.creditCard?.enable ? stripeprofileDetails.profileDetails?.paymentMethod?.creditCard : { enable: false, chargeToCustomer: false },
              },
            },
            addedByUserId: userReduxState.userData?._id,
          })
          setIsThereStripeChange(true)
        }
        if (manageClassesRequest.data.data?.myConnectedPaymentProfiles?.tikkie) {
          let tikkieprofileDetails = manageClassesRequest.data.data.myConnectedPaymentProfiles.tikkie
          // setIsEditTikkie(true);
          setIsEditTikkie(tikkieprofileDetails?.profileDetails?.accountHolderName && tikkieprofileDetails.profileDetails.accountHolderName !== "");
          setFormValues({
            // businessId: manageClassesRequest.data.data._id,
            businessId: null,
            isEnabled: tikkieprofileDetails.isEnabled,
            accountHolderName: tikkieprofileDetails.profileDetails.accountHolderName,
            appToken: tikkieprofileDetails.profileDetails.appToken,
            paymentType: "Tikkie",
            addedByUserId: userReduxState.userData?._id,
          })
          // setIsThereChange(true)
        }
      }
    }
    await getAvailablePaymentMethods();
    dispatch(setGlobalLoading(false));
    setLoading(false)
  };

  const getAvailablePaymentMethods = async () => {
    const requestConfig = {
      method: "get",
      url: `${getUrlForBookings()}payments/getAvailablePaymentMethods?organizerId=${userReduxState.userData?._id}&paymentMethodsFor=event&bookingFor=event`,
    };
    const response = await axiosInstance(requestConfig);
    if (response.status === 200) {
      if (response.data.statusCode === 403) {
      } else if (response.data.statusCode === 200) {
        if (response.data.data) {
          setAvailablePaymentMethods({
            ...{
              "payAtVenue": {
                "enable": false,
                "processingFeeApplicable": true,
                "reserveNowPaylater": true,
                "paymentGatewayServiceFee": {
                  "paymentProcessingFlatFee": 0,
                  "paymentProcessingPercentage": 0
                }
              }
            },
            ...response.data.data,
          })
        }
      }
    }
  };

  const createStripConnectedAC = async (body) => {

    //   }
    // }, 1000);
    // let popup = window.open("https://example.com", "_blank");

    // }
    // return;
    const managemanageStripConnectedACConfig = {
      method: "post",
      url: `${getUrlForBookings()}payments/createConnectedAC`,
      data: {
        ...body,
        return_url: `${window.location.origin}/my-account/online-payment`,
      },
    };
    dispatch(setGlobalLoading(true));
    dispatch(setActionLoading(true));
    const manageStripConnectedAC = await axiosInstance(managemanageStripConnectedACConfig);
    // dispatch(setGlobalLoading(false));
    // dispatch(setActionLoading(false));
    if (manageStripConnectedAC.status === 200) {
      if (manageStripConnectedAC.data.statusCode === 200) {
        if (manageStripConnectedAC.data?.data?.on_boarding_url && manageStripConnectedAC.data.data.on_boarding_url !== "") {

          // var childStripeWindow = window.open(manageStripConnectedAC.data.data.on_boarding_url, 'Stripe Onboarding', 'toolbar=0,status=0,width=800,height=600');
          window.location = manageStripConnectedAC.data.data.on_boarding_url;
          return;
          // var childStripeWindow = window.open(manageStripConnectedAC.data.data.on_boarding_url, "_blank");


          // }
          // }

          // var timer = setInterval(function () {

          //   }
          // }
        } else {
          addNotificationDialog({
            dialogType: "error",
            dialogTitle: t("errors.errorOccurredTitle"),
            dialogMessage: (manageStripConnectedAC.data.message || t("errors.errorOccurredSubTitle")),
            dialogBtnTitle: t("errors.errorOccurredBtn"),
          })
        }
      }
    }
  };

  const checkStripConnectedProcess = async (timeInterval, childStripeWindow) => {
    const managemanageStripConnectedACConfig = {
      method: "get",
      url: `${getUrlForBookings()}payments/stripeStatus`,
    };
    const manageStripConnectedAC = await axiosInstance(managemanageStripConnectedACConfig);
    if (manageStripConnectedAC.status === 200) {
      if (manageStripConnectedAC.data.statusCode === 200) {
        if (manageStripConnectedAC.data.data.stripeOnBoardindStatus == "SUCCESS") {
          try {
            if (childStripeWindow) {
              childStripeWindow.close()
            }
          } catch (error) {
            console.error(error);
          }
          clearInterval(timeInterval);
          dispatch(setGlobalLoading(false));
          // setCreateStripeDialog(false);
          getPaymentProfile();
        }
      }
    }
  };

  const renderLayout = (layoutType = "full", children) => {
    return layoutType === "tab" ? (children)
      : (layoutType === "full" ? (
        <TwMainLayout
          headTitle={t("linkDescription.paymentProfile")}
          children={<>
            {((location?.state && location.state.hasOwnProperty("origin") && location.state?.origin === "paymentprofile") || userReduxState.businessType !== "event") && (<div className="">
              {children}
            </div>)}
          </>} />
      ) : (children));
  }

  React.useEffect(() => {
    getPaymentProfile(false);
  }, []);


  React.useEffect(() => {

    // let myBusinessProfile = userReduxState?.userData?.myBusinessProfile ?? {}
    let stripeprofileDetails = userReduxState?.userData?.myConnectedPaymentProfiles?.stripe ?? {}
    if (
      stripeprofileDetails.isEnabled != stripeFormValues.isEnabled
    ) {
      //   }))
      //     }))
      //     }))
    }
  }, [stripeFormValues])

  // React.useEffect(() => {
  // }, [stripeFormValues]);

  return renderLayout(screenView, (
    <div className={"flex flex-col md:p-3"}>
      <div className={"divide-y"}>
        <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 md:px-6 md:grid-cols-3 lg:px-8">
          <div className="flex items-start gap-4">
            <img
              className={"rounded-md"}
              src={stripLogo}
              alt={""}
            />
            <div>
              <h2 className="text-base/7 font-semibold">{t("account.stripePaymentSectionTitle")}</h2>
              <p className="mt-1 text-sm/6 text-gray-400">{t("account.stripePaymentSectionSubTitle")}</p>
            </div>
          </div>
          {loading ? (
            <div className={"h-28 w-full grid place-items-center"}>
              <TwLoadingIcon />
            </div>
          ) : (<div className={"flex flex-col gap-4 md:col-span-2"}>
            <div>
              <TwSwitch
                title={t("account.enableStripePaymentsTitle")}
                name={"enablePaymentsViaStripe"}
                checked={stripeFormValues.isEnabled}
                onChange={(checked) => {
                  setStripeFormValues((prevValues) => ({
                    ...prevValues,
                    isEnabled: checked,
                  }))
                  setIsThereStripeChange(false)
                  setIsThereChange(
                    (prevValues) => ({
                      ...prevValues,
                      // addStripePayment: false,
                      stripePaymentEnable: false,
                    }))
                }}
                onClick={(event) => event.stopPropagation()}
              />
              <TwFormHelperText className="pt-2 text-xs sm:w-full md:max-w-lg">{t("account.enableStripePaymentsSubTitle")}</TwFormHelperText>
            </div>

            {stripeFormValues?.profileDetails?.stripeAcId && stripeFormValues?.profileDetails?.stripeAcId !== "" && stripeFormValues?.profileDetails?.stripeOnBoardindStatus == "SUCCESS" ? (
              <>
                <TwInputGroup
                  label={t("account.stripeAccountIdTitle")}
                  placeholder={t("account.stripeAccountIdPlaceholder")}
                  disabled={true}
                  value={stripeFormValues?.profileDetails?.stripeAcId}
                />
                <TwInputGroup
                  label={t("account.stripeEmailAccountTitle")}
                  disabled={true}
                  value={stripeFormValues?.profileDetails?.stripeEmail}
                />
                <TwInputGroup
                  label={t("account.stripeAccountCountryTitle")}
                  disabled={true}
                  value={stripeFormValues?.profileDetails?.stripeCountry}
                />
                {/* <TwLabel error={formErrors["paymentMethod"] ? true : false}>{t("bookings.paymentMethod")}</TwLabel>
                <div className={"flex flex-col gap-4 sm:w-full md:max-w-lg"}>
                  <StripPaymentMethod
                    title={<div className="inline-flex items-center gap-2"><img className="size-6" src={iDEALIcon} alt="Ideal" /> Ideal </div>}
                    subTitle={`Payment processing fee: ${((availablePaymentMethods?.ideal?.paymentGatewayServiceFee?.paymentProcessingPercentage > 0 ? availablePaymentMethods?.ideal?.paymentGatewayServiceFee?.paymentProcessingPercentage + "% +" : "") || "")} ${(availablePaymentMethods?.ideal?.paymentGatewayServiceFee?.paymentProcessingFlatFee || 0)} €.`}
                    infoMessage=""
                    defaultSwitch={stripeFormValues?.profileDetails?.paymentMethod?.ideal?.enable || false}
                    defaultChargeToCustomerSwitch={stripeFormValues?.profileDetails?.paymentMethod?.ideal?.chargeToCustomer || false}
                    disabled={!stripeFormValues.isEnabled}
                    onSwitchChange={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            ideal: {
                              ...prevValues.profileDetails?.paymentMethod.ideal,
                              enable: checked,
                            },
                          },
                        },
                      }))
                      setIsThereStripeChange(false)
                    }}
                    onSwitchChangeChargeToCustomer={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            ideal: {
                              ...prevValues.profileDetails?.paymentMethod.ideal,
                              chargeToCustomer: checked,
                            },
                          },
                        },
                      }))
                      setIsThereStripeChange(false)
                    }}
                  />
                  <StripPaymentMethod
                    title={<div className="inline-flex items-center gap-2"><img className="h-6" src={AppleIcon} alt="Apple Pay" /> Apple Pay / <img className="size-5" src={GoogleIcon} alt="Google Pay" />Google Pay </div>}
                    subTitle={`Payment processing fee: ${((availablePaymentMethods?.applePay?.paymentGatewayServiceFee?.paymentProcessingPercentage > 0 ? availablePaymentMethods?.applePay?.paymentGatewayServiceFee?.paymentProcessingPercentage + "% +" : "") || "")} ${(availablePaymentMethods?.applePay?.paymentGatewayServiceFee?.paymentProcessingFlatFee || 0)} €.`}
                    infoMessage=""
                    defaultSwitch={stripeFormValues?.profileDetails?.paymentMethod?.applePay?.enable || false}
                    defaultChargeToCustomerSwitch={stripeFormValues?.profileDetails?.paymentMethod?.applePay?.chargeToCustomer || false}
                    disabled={!stripeFormValues.isEnabled}
                    onSwitchChange={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            applePay: {
                              ...prevValues.profileDetails?.paymentMethod.applePay,
                              enable: checked,
                            },
                            googlePay: {
                              ...prevValues.profileDetails?.paymentMethod.googlePay,
                              enable: checked,
                            },
                          },
                        },
                      }))
                      setIsThereStripeChange(false)
                    }}
                    onSwitchChangeChargeToCustomer={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            applePay: {
                              ...prevValues.profileDetails?.paymentMethod.applePay,
                              chargeToCustomer: checked,
                            },
                            googlePay: {
                              ...prevValues.profileDetails?.paymentMethod.googlePay,
                              chargeToCustomer: checked,
                            },
                          },
                        },
                      }))
                      setIsThereStripeChange(false)
                    }}
                  />
                  <StripPaymentMethod
                    title={<div className="inline-flex items-center gap-2"><CardIcon className="size-5" /> Credit Card</div>}
                    subTitle={`Payment processing fee: ${((availablePaymentMethods?.creditCard?.paymentGatewayServiceFee?.paymentProcessingPercentage > 0 ? availablePaymentMethods?.creditCard?.paymentGatewayServiceFee?.paymentProcessingPercentage + "% +" : "") || "")} ${(availablePaymentMethods?.creditCard?.paymentGatewayServiceFee?.paymentProcessingFlatFee || 0)} €.`}
                    infoMessage=""
                    defaultSwitch={stripeFormValues?.profileDetails?.paymentMethod?.creditCard?.enable || false}
                    defaultChargeToCustomerSwitch={stripeFormValues?.profileDetails?.paymentMethod?.creditCard?.chargeToCustomer || false}
                    disabled={!stripeFormValues.isEnabled}
                    onSwitchChange={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            creditCard: {
                              ...prevValues.profileDetails?.paymentMethod.creditCard,
                              enable: checked,
                            },
                          },
                        },
                      }))
                      setIsThereStripeChange(false)
                    }}
                    onSwitchChangeChargeToCustomer={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            creditCard: {
                              ...prevValues.profileDetails?.paymentMethod.creditCard,
                              chargeToCustomer: checked,
                            },
                          },
                        },
                      }))
                      setIsThereStripeChange(false)
                    }}
                  />
                </div> */}
                {/* {formErrors["paymentMethod"] && (
                  <TwFormHelperText error={formErrors?.paymentMethod !== ""}>{formErrors["paymentMethod"]}</TwFormHelperText>
                )} */}
                {formErrors["stripeAcId"] && (
                  <TwFormHelperText error={formErrors?.stripeAcId !== ""}>{formErrors["stripeAcId"]}</TwFormHelperText>
                )}
                <div className={"flex flex-row items-center gap-2"}>
                  <TwButton
                    variant={isEditStripe ? "secondary" : "primary"}
                    className="sm:min-w-32"
                    // disabled={loadingReduxState.sectionLoading || isThereStripeChange}
                    // disabled={loadingReduxState.actionLoading || isThereStripeChange}
                    disabled={loadingReduxState.actionLoading || isThereChange.stripePaymentEnable}
                    actionLoading={(loadingReduxState.actionLoading)}
                    onClick={() => {
                      saveStripePaymentProfile();

                      setIsThereChange(
                        (prevValues) => ({
                          ...prevValues,
                          stripePaymentEnable: true,
                        }))
                    }}
                  >
                    {isEditStripe ? t("update") : t("account.enableStripePaymentsBtn")}
                  </TwButton>
                </div>
              </>) : stripeFormValues.isEnabled ? (
                <>
                  <TwInputGroup
                    label={t("inputFieldsTitle.email")}
                    name={"email"}
                    type={"email"}
                    placeholder={t("inputFieldsTitle.email")}
                    // leftIcon={(<img className={""} src={customer_name} alt={""} />)}
                    value={stripOnbordingFormValues.email}
                    onChange={(event) => {
                      setStripOnbordingFormValues((prevValues) => ({
                        ...prevValues,
                        email: event.target.value,
                      }));
                      setIsThereChange(
                        (prevValues) => ({
                          ...prevValues,
                          addStripePayment: false,
                          stripePaymentEnable: false,
                        }))
                    }}
                    errors={stripOnbordingFormErrors}
                  />
                  <TwSelectGroup
                    label={t("profile.country")}
                    placeholder={t("profile.selectCountry")}
                    name={"country"}
                    // leftIcon={(<img className={""} src={customer_name} alt={""} />)}
                    options={countryOpts.map((country, idx) => {
                      return { value: country.iso, title: country.name }
                    })}
                    defaultValue={countryOpts[2]}
                    value={stripOnbordingFormValues.country}
                    onChange={(event) => {
                      setStripOnbordingFormValues((prevValues) => ({
                        ...prevValues,
                        // country: event.target.value.iso,
                        country: event.target.value,
                      }));
                      setIsThereChange(
                        (prevValues) => ({
                          ...prevValues,
                          addStripePayment: false,
                          stripePaymentEnable: false,
                        }))
                    }}
                    errors={stripOnbordingFormErrors} />
                  <div className={"flex flex-row items-center gap-2"}>
                    <TwButton
                      className="sm:min-w-32"
                      disabled={loadingReduxState.actionLoading}
                      actionLoading={(loadingReduxState.actionLoading)}
                      onClick={async () => {
                        const errors = {};
                        if (!stripOnbordingFormValues.email) {
                          errors.email = t("errors.required");
                        } else if (stripOnbordingFormValues.email.length > 0 && isValidEmail(stripOnbordingFormValues.email) === false) {
                          errors.email = t("errors.enterValidEmail");
                        }
                        if (!stripOnbordingFormValues.country) {
                          errors.country = t("errors.required");
                        }
                        setStripOnbordingFormErrors(errors)
                        if (Object.keys(errors).length === 0) {
                          await createStripConnectedAC(stripOnbordingFormValues);
                          setIsThereChange(
                            (prevValues) => ({
                              ...prevValues,
                              addStripePayment: true,
                              stripePaymentEnable: true,
                            }))
                        }
                      }}
                    >
                      {t("account.enableStripePaymentsBtn")}
                    </TwButton>
                  </div>
                </>

              ) : null}
          </div>)}
        </div>
        <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 md:px-6 md:grid-cols-3 lg:px-8">
          <div className="flex items-start gap-4">
            {/* <img
              className={"rounded-md"}
              src={stripLogo}
              alt={""}
            /> */}
            <div>
              <h2 className="text-base/7 font-semibold">{t("account.enablePaymentMethodsTitle")}</h2>
              <p className="mt-1 text-sm/6 text-gray-400">{t("account.enablePaymentMethodsSubTitle")}</p>
            </div>
          </div>
          {loading ? (
            <div className={"h-28 w-full grid place-items-center"}>
              <TwLoadingIcon />
            </div>
          ) : (<div className={"flex flex-col gap-4 md:col-span-2"}>
            {stripeFormValues?.profileDetails?.stripeAcId && stripeFormValues?.profileDetails?.stripeAcId !== "" && stripeFormValues?.profileDetails?.stripeOnBoardindStatus == "SUCCESS" ? (
              <>
                {/* <TwLabel error={formErrors["paymentMethod"] ? true : false}>{t("bookings.paymentMethod")}</TwLabel> */}
                <div className={"flex flex-col gap-4 sm:w-full md:max-w-lg"}>
                  <StripPaymentMethod
                    title={<div className="inline-flex items-center gap-2"><img className="size-6" src={iDEALIcon} alt="Ideal" /> Ideal </div>}
                    subTitle={t("account.paymentProcessingFeeSubTitle", { processingFee: `${((availablePaymentMethods?.ideal?.paymentGatewayServiceFee?.paymentProcessingPercentage > 0 ? availablePaymentMethods?.ideal?.paymentGatewayServiceFee?.paymentProcessingPercentage + "% +" : "") || "")} ${(availablePaymentMethods?.ideal?.paymentGatewayServiceFee?.paymentProcessingFlatFee || 0)} €.` })}
                    infoMessage=""
                    defaultSwitch={stripeFormValues?.profileDetails?.paymentMethod?.ideal?.enable || false}
                    defaultChargeToCustomerSwitch={stripeFormValues?.profileDetails?.paymentMethod?.ideal?.chargeToCustomer || false}
                    disabled={!stripeFormValues.isEnabled}
                    onSwitchChange={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            ideal: {
                              ...prevValues.profileDetails?.paymentMethod.ideal,
                              enable: checked,
                            },
                          },
                        },
                      }))
                      setIsThereChange(
                        (prevValues) => ({
                          ...prevValues,
                          stripePaymentMethods: false,
                        }))
                    }}
                    onSwitchChangeChargeToCustomer={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            ideal: {
                              ...prevValues.profileDetails?.paymentMethod.ideal,
                              chargeToCustomer: checked,
                            },
                          },
                        },
                      }))
                      setIsThereChange(
                        (prevValues) => ({
                          ...prevValues,
                          stripePaymentMethods: false,
                        }))
                    }}
                  />
                  <StripPaymentMethod
                    title={<div className="inline-flex items-center gap-2"><img className="h-6" src={AppleIcon} alt="Apple Pay" /> Apple Pay / <img className="size-5" src={GoogleIcon} alt="Google Pay" />Google Pay </div>}
                    subTitle={t("account.paymentProcessingFeeSubTitle", { processingFee: `${((availablePaymentMethods?.applePay?.paymentGatewayServiceFee?.paymentProcessingPercentage > 0 ? availablePaymentMethods?.applePay?.paymentGatewayServiceFee?.paymentProcessingPercentage + "% +" : "") || "")} ${(availablePaymentMethods?.applePay?.paymentGatewayServiceFee?.paymentProcessingFlatFee || 0)} €.` })}
                    infoMessage=""
                    defaultSwitch={stripeFormValues?.profileDetails?.paymentMethod?.applePay?.enable || false}
                    defaultChargeToCustomerSwitch={stripeFormValues?.profileDetails?.paymentMethod?.applePay?.chargeToCustomer || false}
                    disabled={!stripeFormValues.isEnabled}
                    onSwitchChange={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            applePay: {
                              ...prevValues.profileDetails?.paymentMethod.applePay,
                              enable: checked,
                            },
                            googlePay: {
                              ...prevValues.profileDetails?.paymentMethod.googlePay,
                              enable: checked,
                            },
                          },
                        },
                      }))
                      setIsThereChange(
                        (prevValues) => ({
                          ...prevValues,
                          stripePaymentMethods: false,
                        }))
                    }}
                    onSwitchChangeChargeToCustomer={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            applePay: {
                              ...prevValues.profileDetails?.paymentMethod.applePay,
                              chargeToCustomer: checked,
                            },
                            googlePay: {
                              ...prevValues.profileDetails?.paymentMethod.googlePay,
                              chargeToCustomer: checked,
                            },
                          },
                        },
                      }))
                      setIsThereChange(
                        (prevValues) => ({
                          ...prevValues,
                          stripePaymentMethods: false,
                        }))
                    }}
                  />
                  <StripPaymentMethod
                    title={<div className="inline-flex items-center gap-2"><CardIcon className="size-5" /> Credit Card</div>}
                    subTitle={t("account.paymentProcessingFeeSubTitle", { processingFee: `${((availablePaymentMethods?.creditCard?.paymentGatewayServiceFee?.paymentProcessingPercentage > 0 ? availablePaymentMethods?.creditCard?.paymentGatewayServiceFee?.paymentProcessingPercentage + "% +" : "") || "")} ${(availablePaymentMethods?.creditCard?.paymentGatewayServiceFee?.paymentProcessingFlatFee || 0)} €.` })}
                    infoMessage=""
                    defaultSwitch={stripeFormValues?.profileDetails?.paymentMethod?.creditCard?.enable || false}
                    defaultChargeToCustomerSwitch={stripeFormValues?.profileDetails?.paymentMethod?.creditCard?.chargeToCustomer || false}
                    disabled={!stripeFormValues.isEnabled}
                    onSwitchChange={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            creditCard: {
                              ...prevValues.profileDetails?.paymentMethod.creditCard,
                              enable: checked,
                            },
                          },
                        },
                      }))
                      setIsThereChange(
                        (prevValues) => ({
                          ...prevValues,
                          stripePaymentMethods: false,
                        }))
                    }}
                    onSwitchChangeChargeToCustomer={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            creditCard: {
                              ...prevValues.profileDetails?.paymentMethod.creditCard,
                              chargeToCustomer: checked,
                            },
                          },
                        },
                      }))
                      setIsThereChange(
                        (prevValues) => ({
                          ...prevValues,
                          stripePaymentMethods: false,
                        }))
                    }}
                  />
                </div>
                {formErrors["paymentMethod"] && (
                  <TwFormHelperText error={formErrors?.paymentMethod !== ""}>{formErrors["paymentMethod"]}</TwFormHelperText>
                )}
                {/* {formErrors["stripeAcId"] && (
                  <TwFormHelperText error={formErrors?.stripeAcId !== ""}>{formErrors["stripeAcId"]}</TwFormHelperText>
                )} */}
                <div className={"flex flex-row items-center gap-2"}>
                  {/* {isThereStripeChange === true ? "true" : "false"} */}
                  <TwButton
                    variant={isEditStripe ? "secondary" : "primary"}
                    className="sm:min-w-32"
                    // disabled={loadingReduxState.sectionLoading || isThereStripeChange}
                    disabled={loadingReduxState.actionLoading || isThereChange.stripePaymentMethods}
                    actionLoading={(loadingReduxState.actionLoading)}
                    onClick={() => {
                      saveStripePaymentProfile();
                      setIsThereChange(
                        (prevValues) => ({
                          ...prevValues,
                          stripePaymentMethods: true,
                        }))
                    }}
                  >
                    {isEditStripe ? t("update") : t("account.enableStripePaymentsBtn")}
                  </TwButton>
                </div>
              </>) : stripeFormValues.isEnabled ? (
                <></>

              ) : null}
          </div>)}
        </div>
        <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 md:px-6 md:grid-cols-3 lg:px-8">
          <div className="flex items-start gap-4">
            {/* <img
              className={"rounded-md"}
              src={stripLogo}
              alt={""}
            /> */}
            <div>
              <h2 className="text-base/7 font-semibold">{t("account.payoutScheduleTitle")}</h2>
              <p className="mt-1 text-sm/6 text-gray-400">{t("account.payoutScheduleSubTitle")}</p>
            </div>
          </div>
          {loading ? (
            <div className={"h-28 w-full grid place-items-center"}>
              <TwLoadingIcon />
            </div>
          ) : (<div className={"flex flex-col gap-4 md:col-span-2"}>
            {stripeFormValues?.profileDetails?.stripeAcId && stripeFormValues?.profileDetails?.stripeAcId !== "" && stripeFormValues?.profileDetails?.stripeOnBoardindStatus == "SUCCESS" ? (
              <>
                {/* <TwLabel error={formErrors["paymentMethod"] ? true : false}>{t("bookings.paymentMethod")}</TwLabel> */}
                <div className={"flex flex-col gap-4 sm:w-full md:max-w-lg"}>
                  <PayoutScheduleForm
                    reload={() => {
                      //   }))
                    }}
                  />
                </div>
              </>) : stripeFormValues.isEnabled ? (
                <></>

              ) : null}
          </div>)}
        </div>
        {userReduxState.businessType !== "event" && (<div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 md:px-6 md:grid-cols-3 lg:px-8">
          <div className="flex items-start gap-4">
            <img
              className={"rounded-md"}
              src={tikkieLogo}
              alt={""}
            />
            <div>
              <h2 className="text-base/7 font-semibold">Accept online payments via Tikkie</h2>
              <p className="mt-1 text-sm/6 text-gray-400">Add your Tikkie business account here to accept online payments, and  get paid directly into your account. Manage all from a single app</p>
              <p className="mt-1 text-xs text-gray-400">No processing fee | {availablePaymentMethods?.tikkie?.processingFeeApplicable ? (availablePaymentMethods?.tikkie?.paymentGatewayServiceFee?.paymentProcessingPercentage || 0) : 0}% commision</p>
            </div>
          </div>
          <div className={"flex flex-col gap-4 md:col-span-2"}>
            {availablePaymentMethods?.tikkie?.allowAccess ? (
              <>
                <div>
                  <TwSwitch
                    title={"Enable Payments via Tikkie"}
                    name={"enablePaymentsViaTikkie"}
                    checked={formValues.isEnabled}
                    onChange={(checked) => {
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        isEnabled: checked,
                      }))
                      // setIsThereChange(false)
                    }}
                    onClick={(event) => event.stopPropagation()}
                  />
                  <TwFormHelperText className="pt-2 text-xs sm:w-full md:max-w-lg">By enabling this, you agree that all payments and refunds will be handled between you and your customer directly via your Tikkie account, while Bookzy app will only act as digital enabler for those payments.</TwFormHelperText>
                </div>
                {(formValues.isEnabled || formValues.appToken) && (<>
                  <TwInputGroup
                    label={"Name on the Tikkie Account"}
                    name={"accountHolderName"}
                    placeholder={t("account.stripeAccountIdPlaceholder")}
                    disabled={!formValues.isEnabled}
                    value={formValues.accountHolderName}
                    onChange={handleFormValueChange}
                  />
                  <TwInputGroup
                    label={"Enter your Tikkie appToken"}
                    name={"appToken"}
                    placeholder={"e.g. f1912413-6be9-4816-964c-8bba43d9e10f"}
                    disabled={!formValues.isEnabled}
                    value={typeof formValues.appToken == "string" ? formValues.appToken : ""}
                    onChange={handleFormValueChange}
                  />
                  <TwLabel>
                    <a className="text-sm mdtext-base cursor-pointer" href="https://bmcapp.s3.eu-west-1.amazonaws.com/teacher/handleiding_token+aanmaken_V2+(1).pdf" underline="none" rel="noreferrer" target="_blank">
                      Where to find this?
                      <svg className="inline align-middle cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.001 20H6.00098C4.89641 20 4.00098 19.1046 4.00098 18V7C4.00098 5.89543 4.89641 5 6.00098 5H10.001V7H6.00098V18H17.001V14H19.001V18C19.001 19.1046 18.1055 20 17.001 20ZM11.701 13.707L10.291 12.293L16.584 6H13.001V4H20.001V11H18.001V7.415L11.701 13.707Z" fill="#2E3A59" />
                      </svg>
                    </a>
                  </TwLabel>
                  <div className={"flex flex-row items-center gap-2"}>
                    {/* {isThereStripeChange === true ? "true" : "false"} */}
                    <TwButton
                      variant={isEditStripe ? "secondary" : "primary"}
                      className="sm:min-w-32"
                      // disabled={loadingReduxState.sectionLoading || isThereStripeChange}
                      disabled={loadingReduxState.actionLoading || isThereChange.addTikkiePayment}
                      actionLoading={loadingReduxState.actionLoading}
                      onClick={() => {
                        saveTikkiePaymentProfile();
                      }}
                    >
                      {isEditTikkie ? t("update") : "Add my Tikkie Account"}
                    </TwButton>
                  </div>
                  <div className="flex justify-center items-center mt-6 md:mt-10 sm:w-full md:max-w-lg">
                    <a className="text-sm mdtext-base text-gray-700 cursor-pointer" href="https://www.abnamro.nl/nl/zakelijk/producten/zakelijke-rekening/openen.html" underline="none" rel="noreferrer" target="_blank">
                      Do not have a Tikkie Business Account? <span className="text-secondary">Click here</span>
                      <svg className="inline align-middle cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.001 20H6.00098C4.89641 20 4.00098 19.1046 4.00098 18V7C4.00098 5.89543 4.89641 5 6.00098 5H10.001V7H6.00098V18H17.001V14H19.001V18C19.001 19.1046 18.1055 20 17.001 20ZM11.701 13.707L10.291 12.293L16.584 6H13.001V4H20.001V11H18.001V7.415L11.701 13.707Z" fill="#2E3A59" />
                      </svg>
                    </a>
                  </div>
                </>)}
              </>) : (
              <>
                <TwLabel className="sm:w-full md:max-w-lg">
                  <p className="text-[#32282FCC] text-lg mt-4">
                    You need to subscribe to a paid subscription to enable payments through Tikkie
                  </p>
                </TwLabel>
                <div className={"flex flex-row items-center gap-2"}>
                  {/* {isThereChange === true ? "true" : "false"} */}
                  <TwButton
                    className="sm:min-w-32"
                    disabled={loadingReduxState.actionLoading || isThereChange}
                    actionLoading={(loadingReduxState.actionLoading)}
                    onClick={() => {
                      navigate("/businessprofilesetup/subscription", {
                        state: {
                          origin: "paymentprofile",
                        },
                        replace: true
                      });
                    }}
                  >
                    Go to Subscription
                  </TwButton>
                </div>
              </>
            )}
          </div>
        </div>)}
      </div>
    </div>
  ));
}
